import { ReportGmailerrorredOutlined as ReportGmailerrorredOutlinedIcon } from '@frontierag/frontier-ui-library/icons';
import { FEATURE_FLAGS_PAGES_FAILED_ORDERS_ENABLED, ROUTE_ORDERS_FAILED } from 'appConstants';

export const fertMenuItems = [
  {
    icon: <ReportGmailerrorredOutlinedIcon />,
    label: 'failedOrders',
    url: ROUTE_ORDERS_FAILED,
    shouldHideMenuItem: !FEATURE_FLAGS_PAGES_FAILED_ORDERS_ENABLED,
  },
];
